var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "inner",
    { on: { apply: _vm.applyFilter, clear: _vm.clear } },
    [
      _c("custom-select-price-dropdown-content", {
        staticClass: "panel-content",
        attrs: {
          from: _vm.from,
          to: _vm.to,
          min: _vm.minMax.min.toString(),
          max: _vm.minMax.max.toString()
        },
        on: { "update-price": _vm.updatePrice }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }